import {ActionMethod, ActionOrigin} from 'constants/AnalyticsConstants';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import * as ProcessManagementDAO from 'processes/dao/ProcessManagementDAO';
import {outputTableToOutputsForCreate} from 'processes/tables/outputTableToOutputsUtils';
import taskTableToTasks from 'processes/tables/taskTableToTasks';

import {FromItemIdsToTables} from './FixFailedRoutingAndMappingConstants';

export interface BuildSpecsResult {
  taskSpecs: Array<ProcessManagementDAO.CreateServerProcessTask>;
  outputSpecs: Array<ProcessManagementDAO.CreateServerProcessOutput>;
}

export function buildFixFailedMappingSpecs(
  fromItemIdsToTables: FromItemIdsToTables,
  rootTaskId: string,
  rootProcessId: string
): BuildSpecsResult {
  const taskSpecs: Array<ProcessManagementDAO.CreateServerProcessTask> = [];
  const outputSpecs: Array<ProcessManagementDAO.CreateServerProcessOutput> = [];

  for (const [fromItemId, mappingData] of Object.entries(fromItemIdsToTables)) {
    for (const data of mappingData) {
      if (data.structuredTable.kind === StructuredTableKind.PROCESS_TASK) {
        taskSpecs.push(
          ...taskTableToTasks({
            table: data.structuredTable,
            evaluatedTable: data.computedTable,
            sourceType: 'continue_flowchart_dashboard',
            actionOrigin: ActionOrigin.WORKFLOWS_DASHBOARD,
            actionMethod: ActionMethod.BUTTON_CLICK,
          }).map((task) => ({
            ...task,
            nodeConfigId: data.mapper.toNodeConfig.id,
            fromItemId,
            schemaMapperId: data.mapper.id,
          }))
        );
      } else if (data.structuredTable.kind === StructuredTableKind.PROCESS_OUTPUT) {
        outputSpecs.push(
          ...outputTableToOutputsForCreate({
            table: data.structuredTable,
            evaluatedTable: data.computedTable,
            sourceType: 'continue_flowchart_dashboard',
            actionOrigin: ActionOrigin.WORKFLOWS_DASHBOARD,
            actionMethod: ActionMethod.BUTTON_CLICK,
            schemaMapperId: data.mapper.id,
            taskIds: new Array(data.structuredTable.rows.length).fill(rootTaskId),
            fromItemIds: new Array(data.structuredTable.rows.length).fill(fromItemId),
            creationOriginIds: new Array(data.structuredTable.rows.length).fill(rootProcessId),
          })
        );
      }
    }
  }

  return {taskSpecs, outputSpecs};
}
